import {CATEGORIES, CATEGORY_GROUP} from '@/enums';

export const MYFC_CATEGORIES = [
  `${CATEGORIES.COFFEE}`,
  `${CATEGORIES.BAKERY}`,
  `${CATEGORIES.DESSERT}`,
  `${CATEGORIES.KOREAN}`,
  `${CATEGORIES.CHINESE}`,
  `${CATEGORIES.JAPANESE}`,
  `${CATEGORIES.WESTERN}`,
  `${CATEGORIES.FUSION}`,
  `${CATEGORIES.PUB}`,
  `${CATEGORIES.CHICKEN}`,
  `${CATEGORIES.PIZZA}`,
  `${CATEGORIES.SNACK}`,
  `${CATEGORIES.FASTFOOD}`,
  `${CATEGORIES.CONVENIENCE}`,
  `${CATEGORIES.WHOLESALE_RETAIL}`,
  `${CATEGORIES.INTERNET_CAFE}`,
  `${CATEGORIES.LEISURE}`,
  `${CATEGORIES.EDUCATION}`,
  `${CATEGORIES.STUDY}`,
  `${CATEGORIES.LAUNDRY}`,
  `${CATEGORIES.LIFE}`,
];

export const CATEGORY_ID = {
  [CATEGORIES.COFFEE]: 'coffee',
  [CATEGORIES.BAKERY]: 'bakery',
  [CATEGORIES.DESSERT]: 'dessert',
  [CATEGORIES.KOREAN]: 'korean',
  [CATEGORIES.CHINESE]: 'chinese',
  [CATEGORIES.JAPANESE]: 'japanese',
  [CATEGORIES.WESTERN]: 'western',
  [CATEGORIES.FUSION]: 'fusion',
  [CATEGORIES.PUB]: 'pub',
  [CATEGORIES.CHICKEN]: 'chicken',
  [CATEGORIES.PIZZA]: 'pizza',
  [CATEGORIES.SNACK]: 'snack',
  [CATEGORIES.FASTFOOD]: 'fastfood',
  [CATEGORIES.CONVENIENCE]: 'convenience',
  [CATEGORIES.WHOLESALE_RETAIL]: 'wholesaleRetail',
  [CATEGORIES.INTERNET_CAFE]: 'internetCafe',
  [CATEGORIES.LEISURE]: 'leisure',
  [CATEGORIES.EDUCATION]: 'education',
  [CATEGORIES.STUDY]: 'study',
  [CATEGORIES.LAUNDRY]: 'laundry',
  [CATEGORIES.LIFE]: 'life',
};

export const CATEGORY_GROUP_MAP = {
  [CATEGORY_GROUP.CAFE]: [
    CATEGORIES.COFFEE,
    CATEGORIES.BAKERY,
    CATEGORIES.DESSERT,
  ],
  [CATEGORY_GROUP.RESTAURANT]: [
    CATEGORIES.KOREAN,
    CATEGORIES.CHINESE,
    CATEGORIES.JAPANESE,
    CATEGORIES.WESTERN,
    CATEGORIES.FUSION,
    CATEGORIES.PUB,
  ],
  [CATEGORY_GROUP.CHICKEN_PIZZA]: [CATEGORIES.CHICKEN, CATEGORIES.PIZZA],
  [CATEGORY_GROUP.FASTFOOD]: [CATEGORIES.SNACK, CATEGORIES.FASTFOOD],
  [CATEGORY_GROUP.RETAIL]: [
    CATEGORIES.CONVENIENCE,
    CATEGORIES.WHOLESALE_RETAIL,
  ],
  [CATEGORY_GROUP.LEISURE]: [CATEGORIES.INTERNET_CAFE, CATEGORIES.LEISURE],
  [CATEGORY_GROUP.SERVICE]: [
    CATEGORIES.EDUCATION,
    CATEGORIES.STUDY,
    CATEGORIES.LAUNDRY,
    CATEGORIES.LIFE,
  ],
};
